import { Button, Progress, message } from "antd";
import { FiArrowRight } from "react-icons/fi";
import styles from "./CartOrderSummary.module.scss";
import { FaCreditCard } from "react-icons/fa";

const CartOrderSummary = ({
  cartContext,
  step,
  setStep,
  personalForm,
  shippingForm,
  orderPlaceHandler,
}) => {
  const handleOnClick = () => {
    if (step === 2) {
      personalForm.submit();
      shippingForm?.submit();
    } else if (step === 4) {
      orderPlaceHandler();
    } else {
      cartContext.cartItems.length > 0
        ? setStep(step + 1)
        : message.error("Your cart is empty!");
    }
  };

  return (
    <>
      <div className={styles.order_summary_wrapper}>
        {window.innerWidth < 576 && (
          <div className={styles.title}>
            <p>Summary</p>
          </div>
        )}
        <div className={"dt_only"}>
          <div>
            <Button
              block
              size="large"
              style={{
                display: "flex",
                justifyContent: "center",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                backgroundColor: "var(--color-orange)",
              }}
              onClick={handleOnClick}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "var(--color-primary)",
                }}
              >
                <FaCreditCard size={20} style={{ marginRight: 10 }} />
                <span style={{ fontWeight: 600 }}>
                  {step === 1
                    ? "CHECKOUT"
                    : step === 2
                      ? "Payment Method"
                      : step === 3
                        ? "Review & Confirm"
                        : "Place Order"}
                </span>
                <FiArrowRight
                  size={18}
                  style={{ marginLeft: "1rem", color: "var(--color-primary)" }}
                />
              </div>
            </Button>
            <div className={styles.secure_payment}>
              <img src="/icon/checkout/lock.svg" alt="" />
              Secure Payment Guaranteed
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: "1rem",
          }}
          className={"dt_only"}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Progress
              strokeColor={{
                "0%": "var(--color-primary)",
                "100%": "#87d068",
              }}
              percent={(100 * cartContext.calculateOrderSubTotal()) / 39.99}
              showInfo={false}
              status="active"
            />
            <div>
              {cartContext.calculateOrderSubTotal() > 39.99 ? (
                <>
                  <span>You have obtained free home delivery</span>
                </>
              ) : (
                <>
                  <span>
                    Please add{" "}
                    <span
                      style={{
                        fontSize: "1.6rem",
                        fontWeight: "bold",
                        color: "var(--color-dark)",
                      }}
                    >
                      €
                      {parseFloat(
                        49.99 - cartContext.calculateOrderSubTotal(),
                      ).toFixed(2)}
                    </span>{" "}
                    worth product to obtain free delivery
                  </span>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={styles.order_summary_bottom}>
          <div className={styles.summary_item}>
            <span>Sub Total Article Price (Excl. VAT)</span>
            <span
              style={{ color: "var(--color-dark)" }}
              className={styles.rb_text}
            >
              {parseFloat(cartContext.calculateOrderSubTotalExclVat()).toFixed(
                2,
              )}{" "}
              €
            </span>
          </div>

          <div className={styles.summary_item}>
            <span>Articles</span>
            <span style={{ color: "var(--color-dark)" }}>
              ({cartContext.cartItems.length})
            </span>
          </div>

          <div className={styles.summary_item}>
            <span>Weight(≈)</span>
            <span style={{ color: "var(--color-dark)" }}>
              {cartContext.getTotalCartWeight()} kg
            </span>
          </div>

          <div className={styles.summary_item}>
            <span>Standard Delivery</span>
            <span style={{ color: "var(--color-dark)" }}>
              {cartContext.deliveryCharge} €
            </span>
          </div>

          <hr />

          <div className={styles.summary_item}>
            <span>Net amount (Incl. VAT)</span>
            <span style={{ color: "var(--color-dark)" }}>
              {parseFloat(
                cartContext.calculateOrderSubTotal() +
                  cartContext.deliveryCharge,
              ).toFixed(2)}{" "}
              €
            </span>
          </div>

          <div className={styles.summary_item}>
            <span>VAT A - 7% ({cartContext.getArticleACount()} articles)</span>
            <span style={{ color: "var(--color-dark)" }}>
              {parseFloat(cartContext.calculateVatA()).toFixed(2)} €
            </span>
          </div>

          <div className={styles.summary_item}>
            <span>VAT B - 19% ({cartContext.getArticleBCount()} articles)</span>
            <span style={{ color: "var(--color-dark)" }}>
              {parseFloat(cartContext.calculateVatB()).toFixed(2)} €
            </span>
          </div>

          <hr />

          <div className={styles.summary_item}>
            <span
              className={"fw-bold " + styles.rb_text}
              style={{ color: "var(--color-dark)" }}
            >
              Total Price <span>(Incl. VAT)</span>
            </span>
            <span
              className={"fw-bold"}
              style={{
                color: "var(--color-dark)",
                fontSize: "14px",
              }}
            >
              {cartContext.calculateOrderTotal()} €
            </span>
          </div>

          {cartContext.saved === "0.00" ? null : (
            <div
              style={{
                backgroundColor: "var(--color-primary)",
                textAlign: "center",
                padding: "5px 0",
                color: "#fff",
              }}
            >
              You saved {cartContext.saved} EUR with Desi Fresh
            </div>
          )}

          {cartContext.calculateOrderSubTotal() > 49 && (
            <Button
              type={"primary"}
              style={{ width: "100%", borderRadius: 0 }}
              className={styles.free_ship + " dt_only mt-3 px-2"}
            >
              <img src="/icon/checkout/free-ship.svg" alt="" />
              Congrats! You've earned free shipping
            </Button>
          )}

          <div className={styles.secure + " dt_only"}>
            <img src="/icon/checkout/lock.svg" alt="" />
            <span>Secure Payment Guaranteed</span>
          </div>

          <div className={styles.info + " dt_only"}>
            <div>
              <p>
                <span>Express delivery available at 3.99€ </span> (Same day
                delivery in Munich). For rest of Germany within 24 hours
              </p>
            </div>
          </div>

          <div className={styles.info + " dt_only"}>
            <div>
              <p>
                <span>Express self pickup available</span> (Free). (*Currently
                available only in Munich)
              </p>
            </div>
          </div>
          <div className={styles.info + " dt_only"}>
            <img style={{ width: "30px" }} src="/icon/df_van.png" alt="" />
            <div>
              <p>
                <span style={{ textDecoration: "none" }}>
                  Guaranteed Fast Delivery
                </span>{" "}
                <br /> Free standard delivery on orders above 49.99 Euro
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartOrderSummary;
